import { contractDate } from "./planningDates";
const id = value => String(value?._id || value || "");
const normalize = value => String(value ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, " ").trim();
const sameClient = (request, contract) => {
 if (request.client?.pld && contract.IdClient != null) return String(contract.IdClient) === String(request.client.pld);
 const name = normalize(request.client?.companyName || request.client?.denomination);
 return Boolean(name) && normalize(contract.RaisonSociale) === name;
};
const sameWorker = (request, contract) => {
 if (request.candidate?.pld && contract.IdInterimaire != null) return String(contract.IdInterimaire) === String(request.candidate.pld);
 const name = normalize([request.candidate?.firstname, request.candidate?.lastname].filter(Boolean).join(" "));
 const reversed = normalize([request.candidate?.lastname, request.candidate?.firstname].filter(Boolean).join(" "));
 return Boolean(name) && [name, reversed].includes(normalize(contract.NomPrenom));
};
// A request is replaced by any contract of the same worker at the same client
// still running on or after the requested day, whatever its exact dates.
export function planningRequests(requests, contracts = []) {
 return requests.flatMap(request => {
  const dates = request.contractType === "vacation" && request.placementDetails?.dates?.length
   ? request.placementDetails.dates.map(row=>({start:row.dateDebut,end:row.dateDebut,startHour:row.startHour,endHour:row.endHour}))
   : [{start:request.startDate,end:request.endDate || request.startDate,startHour:request.startHourString,endHour:request.endHourString}];
  return dates.filter(period=>contractDate(period.start) && !contracts.some(contract=>{
   if (contract.isContractRequest) return false;
   const exact = id(request.orderId) && id(contract.order || contract.orderId)===id(request.orderId) && id(contract.candidate)===id(request.candidate);
   if (!exact && !(sameClient(request, contract) && sameWorker(request, contract))) return false;
   const start=contractDate(contract.DateDebut || contract.startDate);
   const end=contractDate(contract.DateFinMission || contract.DateFin || contract.endDate) || start;
   return Boolean(start) && (!end || end>=contractDate(period.start));
  })).map((period,index)=>({
   _id:`request-${request._id}-${index}`,requestId:request._id,isContractRequest:true,status:"Demandé",
   contractType:request.contractType,client:request.client,candidate:request.candidate,order:request.orderId,
   IdClient:request.client?.pld || id(request.client),IdInterimaire:request.candidate?.pld || id(request.candidate),
   RaisonSociale:request.client?.companyName || request.client?.denomination || "Client",
   NomPrenom:[request.candidate?.firstname,request.candidate?.lastname].filter(Boolean).join(" ") || "Candidat",
   Qualification:request.clientQualification?.TxtQualification || "",
   DateDebut:period.start,DateFin:period.end,HeureDebut:period.startHour,HeureFin:period.endHour,
   NumeroContrat:`Demande ${String(request._id).slice(-6).toUpperCase()}`,
  }));
 });
}
